import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-business-site',
  templateUrl: './business-site.component.html',
  styleUrls: ['./business-site.component.css']
})
export class BusinessSiteComponent implements OnInit {
    businessSiteKeyno;

    public edit?: Edit;

    public selectListBusinessCompanies: BusinesscoItem[] = [];

    public itemsListStockPlaces: Item[] = [];

    public saving = false;

    constructor(private state: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.businessSiteKeyno = this.state.getStateParams()['businesssite_keyno'];
    }

    private async loadEdit() {
        if (!!this.businessSiteKeyno) {
            this.edit = (await this.datatask.Post(1656, { businesssite_keyno: this.businessSiteKeyno }))[0];
        }
    }

    private async loadBusinessCompanies() {
        this.selectListBusinessCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces(): Promise<void> {
        if (this.edit?.businesssite_keyno && this.edit.businesssite_keyno > 0) {
            this.itemsListStockPlaces = await this.datatask.Post(1658, { businesssite_keyno: this.edit.businesssite_keyno });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1657, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.state.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadBusinessCompanies();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businesssite_keyno: number;
    businesssite_name: string;
    businessco_no: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('businessSite', {
//        templateUrl: 'views/components/views/businessSite/businessSite.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'businessSiteService', 'logisticService', function ($stateParams, stateService, utilityService, translateService, modalService, businessSiteService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let businessSiteKeyno = $stateParams.businesssite_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListBusinessCompanies: [],
//                itemsListStockPlaces: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await businessSiteService.getEdit({ businesssite_keyno: businessSiteKeyno }))[0];

//                return loadStockPlaces();
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.edit.businesssite_keyno) !== true) return;

//                if (vm.model.edit.businesssite_keyno > 0) {
//                    return vm.model.itemsListStockPlaces = await businessSiteService.listStockPlaces({ businesssite_keyno: vm.model.edit.businesssite_keyno });
//                }
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                businessSiteService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
